import React, { useEffect, useState } from "react";
import "./archive.css";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { enqueueSnackbar as EnSn } from "notistack";
import { useGetCalculatorsByArchiveQuery, useGetCalculatorsByArchiveOgrnQuery, useDeleteCalculatorMutation, useInWorkCalculatorMutation, useIsPaidCalculatorMutation, useSendPaidCalculatorMutation } from '../../../context/service/calculator.service';
import { useGetUserByIdQuery, useGetManagersQuery, useDeleteUserMutation } from '../../../context/service/user.service';
import { useChangeStatusMutation } from "../../../context/service/auth.service";
import Pagination from '../../../utils/Pagination';
import { useParams, useLocation, Link } from 'react-router-dom';
import { NumericFormat } from "react-number-format";
import Invoices from '../../archive/Invoices';

export const User_view = () => {

    const [page, setPage] = useState(1);
    const [pageManager, setPageManager] = useState(1);
    const { user_id } = useParams();
    const [only, setOnly] = useState(0);
    const { data: userData, error: user_error, isLoading: user_isLoading } = useGetUserByIdQuery(user_id);
    // Делаем оба запроса, но используем только нужный
      const [changeStatus] = useChangeStatusMutation();
      const [deleteUser] = useDeleteUserMutation();
    const archiveQuery = useGetCalculatorsByArchiveQuery(
      { page, user_id: user_id },
      { skip: userData?.innerData?.role === 'organization' }
    );

    const { data: managersData } = useGetManagersQuery({user_id, page: pageManager}, {
      skip: userData?.innerData?.role !== 'organization'
    });

      const managers = managersData?.innerData?.results || null;

    const orgArchiveQuery = useGetCalculatorsByArchiveOgrnQuery(
      { page, user_id: user_id },
      { skip: userData?.innerData?.role !== 'organization' }
    );

    // Выбираем актуальные данные
    const { data, error, isLoading } = userData?.innerData?.role === 'organization' && only === 0
      ? orgArchiveQuery 
      : archiveQuery;

    const [deleteCalculator] = useDeleteCalculatorMutation();
    const [inWorkCalculator] = useInWorkCalculatorMutation();
    const [isPaidCalculator] = useIsPaidCalculatorMutation();
    const [sendPaidMail] = useSendPaidCalculatorMutation();

    // Set initial title
    const [documentTitle, setDocumentTitle] = useState(`Архив расчетов`);

    const archive = data?.innerData?.results || [];
    const totalCount = data?.innerData?.totalCount || 0; 
    const pageSize = data?.innerData?.pageSize || 10; 
    const totalPages = data?.innerData?.totalPages; 
    const user = JSON.parse(localStorage.getItem("user"));

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

    useEffect(() => {
        // Update title when user data is available
        if (userData) {
            setDocumentTitle(`Архив расчетов - Пользователь ${userData?.innerData.lastname}`);
        }
    }, [userData]);

    useEffect(() => {
        document.title = documentTitle;
    }, [documentTitle]);

    // Rest of your component...
    
    if (user_isLoading) return <div>Загрузка данных...</div>;
    if (user_error) return <div>Ошибка загрузки данных...</div>;

  const handleStatusChange = async (user) => {
    try {
      // confirm change status
      let action = user.status === "active" ? "suspended" : "active";
      let set = { id: user.id, status: action };
      const { data = null, error = null } = await changeStatus(set);
      let msg = data?.message || error?.data?.message;
      let variant = data?.variant || error?.data?.variant;
      if (error) return EnSn(msg, { variant });
      EnSn(msg, { variant: data?.variant || error?.data?.variant });
    } catch (error) {
      return EnSn("Failed to change status", { variant: "error" });
    }
  };

  // Handle delete user
  const handleDeleteUser = async (id) => {
    try {
      // confirm delete
      let msg = "Вы хотите удалить следующий профиль?";
      if (!window.confirm(msg)) return;
      const { data = null, error = null } = await deleteUser(id);
      msg = data?.message || error?.data?.message;
      let variant = data?.variant || error?.data?.variant;
      if (error) return EnSn(msg, { variant });
      EnSn(msg, { variant });
      alert("User deleted");
    } catch (error) {
      return EnSn("Failed to delete user", { variant: "error" });
    }
  };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleOnly = () => {
        setPage(1);
        if(only === 1) {
            setOnly(0)
        } else {
            setOnly(1);
        }
    };

    if (isLoading) return <div>Загрузка...</div>;
    if (error) return <div>Ошибка загрузки архивов</div>;

    const handleSendToWork = async (id) => {
        const confirmed = window.confirm("Вы уверены, что хотите отправить в работу этот расчет?");
        if (!confirmed) return;

        let msg, variant;
        const { data = null, error = null } = await inWorkCalculator(id);
        msg = data ? data.message : error?.data?.error;
        variant = data ? data.variant : error?.data?.variant;

        EnSn(msg, { variant });
    };

    const handleDeleteCalc = async (id) => {
        const confirmed = window.confirm("Вы уверены, что хотите удалить этот расчет?");
        if (!confirmed) return;

        let msg, variant;
        const { data = null, error = null } = await deleteCalculator(id);
        msg = data ? data.message : error?.data?.error;
        variant = data ? data.variant : error?.data?.variant;

        EnSn(msg, { variant });
    };

    const SendPaid = (id) => {
        setSelectedInvoiceId(id);
        setIsModalOpen(true);
    };

    const NewSendPaid = async (id, invoice_id = 0) => {
            const response = await sendPaidMail({ id, invoice_id }); // Используйте правильные значения
            const { data, error } = response;

            const msg = data ? data.message : error?.data?.error;
            const variant = data ? data.variant : error?.data?.variant;

            if (error) {
                return EnSn(msg, { variant });
            }
            EnSn(msg, { variant });
            setIsModalOpen(false);
    };

    const changePaid = async (id, paid) => {
        const text = (paid === '1') ? 'Вы уверены, что хотите сменить статус на оплачен?' : 'Вы уверены, что хотите сменить статус на не оплачен?';
        const confirmed = window.confirm(text);
        if (!confirmed) return;

        let msg, variant;
        const { data = null, error = null } = await isPaidCalculator({ id, paid });
        msg = data ? data.message : error?.data?.error;
        variant = data ? data.variant : error?.data?.variant;

        EnSn(msg, { variant });
    };

              const roleTranslations = {
                admin: "Администратор",
                manager: "Менеджер",
                organization: "Организация",
                moderator : 'Модератор'
              };

    return (
        <div className="archive">
        <div className="type_list_user">
            <div className="image">
                    {userData?.innerData?.logo ? (
                        <img className="logo" src={userData?.innerData?.logo} alt="" />
                    ) : (
                        <img src="/icons/login_bg_icon.svg" alt="logo" className="logo" />
                    )}
            </div>
            <h1>{documentTitle.replace('Архив расчетов - ','')}</h1>
            <div className="role">{roleTranslations[userData?.innerData?.role] || userData?.innerData?.role}</div>
              <div className="edit">
                <Link to={`/users/edit/${userData.innerData.id}`}>
                    <button>Редактировать</button>
                </Link>
              </div>
        </div>
        {userData?.innerData?.role === 'manager' && userData?.innerData?.organization_name && (
        <div className="type_list_user">
            <div className="image">
                    {userData?.innerData?.organization_logo ? (
                        <img className="logo" src={userData?.innerData?.organization_logo} alt="" />
                    ) : (
                        <img src="/icons/login_bg_icon.svg" alt="logo" className="logo" />
                    )}
            </div>
              <div className="name_org">
                Организация: {userData.innerData.organization_name}
              </div>
              <div className="view">
                <Link to={`/users/view/${userData.innerData.organization_id}`}>
                    <button>Перейти</button>
                </Link>
              </div>
              <div className="edit">
                <Link to={`/users/edit/${userData.innerData.organization_id}`}>
                    <button>Редактировать</button>
                </Link>
              </div>
        </div>
        )}
        {userData?.innerData?.role === 'manager' && !userData?.innerData?.organization_name && (
            <p>Организации нету</p>
        )}

{userData?.innerData?.role === 'organization' && (
    
  <div className="organization-managers">
    <h1>Список менеджеров организации</h1>
    <div className="managers-list">
      {managers?.length > 0 ? (
        <>
          <div className="home__list">
            <ol className="list_users two">
              <li className="list_users__header">
                <p className="w150">ФИО</p>
                <p className="w150">Почта</p>
                <p className="w150">Телефон</p>
                <p className="w150">Роль</p>
              </li>

              {managers?.map((user_item) => {
                const roleTranslations = {
                  admin: "Администратор",
                  manager: "Менеджер",
                  organization: "Организация",
                  moderator: 'Модератор'
                };

                // Формируем полное имя
                const fullName = `${user_item.firstname || ''} ${user_item.lastname || ''} ${user_item.patronymic || ''}`.trim();

                return (
                  <li className="list_users__item two" key={user_item?.id}>
                    <p className="w150 truncate-text" title={fullName}>
                      {fullName}
                    </p>
                    <p className="w150" title={user_item?.email}>{user_item?.email}</p>
                    <p className="w150">{user_item?.phone}</p>
                    <p className="w150">
                      {roleTranslations[user_item?.role] || user_item?.role} {/* Выводим роль с переводом */}
                    </p>

                    <div className="list_users__item__actions">
                      <Link to={`/users/view/${user_item.id}`}>
                        <button>Посмотреть</button>
                      </Link>

                      <button onClick={() => handleStatusChange(user_item)}>
                        {user_item?.status === "active" ? "Отключить" : "Активировать"}
                      </button>
                      {user?.role === 'admin' && (
                        <button className="delete" onClick={() => handleDeleteUser (user_item?.id)}>
                          Удалить
                        </button>
                      )}
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </>
      ) : (
        <p>Нет доступных менеджеров.</p> // Сообщение, если менеджеров нет
      )}
    </div>
  </div>
)}



        <h1>Список расчётов</h1>
        {userData?.innerData?.role === 'organization' && (
        <label onClick={() => handleOnly()} >{only !== 0 ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />} Без менедежеров</label>
        )}
            <div className="archive__container">
                <ol className="archive__list">
                    <li className="archive__header">
                        <p className="w75">id</p>
                        <p className={user?.role === 'admin' ? 'w140' : 'w170'}>ФИО</p>
                        <p className={user?.role === 'admin' ? 'w140' : 'w170'}>{user?.role === 'admin' ? 'ИНН' : 'Материал и цвет'}</p>
                        <p className="w90">Дата</p>
                        <p className="w90">Сумма у обработчика</p>
                        <p className="w90">Сумма</p>
                        <p className="w90">Наценка</p>
                        <p className="w90">Отправлен в расчет?</p>
                        {(user?.role === 'admin') && <p className="w60">Оплачен</p>}
                    </li>

                    {archive.map((item) => {
                        const date = new Date(item.date);
                        const formattedDate = date.toLocaleDateString('ru-RU');
                        const color = JSON.parse(item.color);
                        const material = JSON.parse(item.material);

                        return (
                            <li className="archive__item" key={item.id}>
                                <p className="w75">{item.id}</p>
                                <p className={user?.role === 'admin' ? 'w140' : 'w170'}>
                                {user?.role === 'admin' ? (
                                    item.user_role === 'admin' ? (
                                        <span>Админ</span>
                                    ) : (
                                        <>
                                            {item.user_lastname} {' '}
                                            {(item.user_fristname?.charAt(0) ?? '')}. {' '}
                                            {(item.user_patronymic?.charAt(0) ?? '')}.
                                        </>
                                    )
                                ) : (
                                    item.fullname
                                )}
                                </p>
                                <p className={user?.role === 'admin' ? 'w140' : 'w170'}>
                                {user?.role === 'admin' ? (
                                    <>
                                        {item.user_role === 'admin' ? (
                                            <span>Админ</span>
                                        ) : (
                                            item.user_inn
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {material ? material.name : 'Цвет не указан'}
                                        <br />
                                        {color ? color.name : 'Цвет не указан'}
                                    </>
                                )}

                                </p>
                                <p className="w90">{formattedDate}</p>
                                <p className="w90">
                                    <NumericFormat
                                        value={item.material_price + item.extras_price}
                                        allowLeadingZeros
                                        thousandSeparator=" "
                                        suffix=" ₽"
                                        displayType="text"
                                    />
                                </p>
                                <p className="w90">
                                    <NumericFormat
                                        value={item.material_price + item.extras_price - item.markup_price}
                                        allowLeadingZeros
                                        thousandSeparator=" "
                                        suffix=" ₽"
                                        displayType="text"
                                    />
                                </p>
                                <p className="w90">
                                    <NumericFormat
                                        value={item.markup_price}
                                        allowLeadingZeros
                                        thousandSeparator=" "
                                        suffix=" ₽"
                                        displayType="text"
                                    />
                                </p>
                                <p className="w90" style={{ borderRight: "none" }}>
                                    {item.status !== 0 ? <MdCheckBox /> : <button className="no_button" onClick={() => handleSendToWork(item.id)}><MdCheckBoxOutlineBlank /></button>}
                                </p>
                                {(user?.role === 'admin' || user?.role === 'moderator') && (
                                    <p className="w60" style={{ borderRight: "none" }}>
                                        {item.paid === '1' ? <button className="no_button" onClick={() => changePaid(item.id, '0')}><MdCheckBox /></button> : <button className="no_button" onClick={() => changePaid(item.id, '1')}><MdCheckBoxOutlineBlank /></button>}
                                    </p>
                                )}

                                <div className="archive__actions">
                                    {(item.status === 0 && user?.role !== 'admin' && user?.role !== 'moderator') && (
                                        <button onClick={() => handleSendToWork(item.id)}>Отправить в работу</button>
                                    )}
                                    <Link to={`/archive/item/${item.id}`}>
                                        <button>Открыть</button>
                                    </Link>
                                    {(user?.role === 'admin' || user?.role === 'moderator') && (
                                        <button onClick={() => SendPaid(item.id)}>Отправить</button>
                                    )}
                                    {(user?.role === 'admin') && (
                                    <button className="delete" onClick={() => handleDeleteCalc(item.id)}>Удалить</button>
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ol>
            </div>
            {totalPages > 1 && (
                <Pagination
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            )}

            <Invoices 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                id={selectedInvoiceId} // Передаем id выбранного счета
                onSendNew={(calculatorId, invoiceId) => NewSendPaid(calculatorId, invoiceId)}
            />
        </div>
    );
};
